import type { ReactElement } from 'react';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { InfoIcon, WarningIcon } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type EmptyStateProps = WithI18nLocale;

export const NoInformationAvailable = ({
  i18nLocale,
}: EmptyStateProps): ReactElement => (
  <FlexBox paddingY="large" align="center" justify="center" gap="small">
    <InfoIcon color={colors.textSubtle} />
    <Text variant="caption" color="textSubtle">
      {t(
        i18nLocale,
        'componentOverview:miniOverview.noInformation',
        'No information available.'
      )}
    </Text>
  </FlexBox>
);

export const ErrorCard = ({ i18nLocale }: EmptyStateProps): ReactElement => (
  <FlexBox paddingY="large" align="center" justify="center" gap="small">
    <WarningIcon color={colors.textWarning} />
    <Text variant="caption" color="textSubtle">
      {t(
        i18nLocale,
        'componentOverview:miniOverview.unavailable',
        "This component isn't available."
      )}
    </Text>
  </FlexBox>
);
